import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSortType } from 'store/search/search-actions';
import { useClearFocus } from 'pages/search/hooks/use-clear-focus';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
import IconChevronDown from '@spothero/icons/chevron-down';
import { FilterCheckboxBase } from '../../../filter-bases';
import AirportSortModal from 'common/airport-sort-modal';
import { SPOT_SORT_OPTIONS } from 'utils/spot-sort';
import { getParkingType } from 'store/selectors/selectors';
export const FilterSpotSort = () => {
    const { clearFocus } = useClearFocus();
    const parkingType = useSelector(getParkingType);
    const isAirport = parkingType === 'airport';
    const dispatch = useDispatch();
    const [showSortByModal, setShowSortByModal] = useState(false);
    const show = useMobileBreakPoint();
    const sortBy = useSelector((state) => state.search.data.sortBy);
    const getSortOptions = useMemo(() => {
        return [
            {
                value: isAirport
                    ? SPOT_SORT_OPTIONS.FEATURED
                    : SPOT_SORT_OPTIONS.RELEVANCE,
                display: 'Relevance',
            },
            {
                value: isAirport
                    ? SPOT_SORT_OPTIONS.SHUTTLE_TIME
                    : SPOT_SORT_OPTIONS.DISTANCE,
                display: isAirport ? 'Shuttle Duration' : 'Distance',
            },
            {
                value: SPOT_SORT_OPTIONS.PRICE,
                display: 'Price',
            },
        ];
    }, [isAirport]);
    const onChangeSort = (event) => {
        setShowSortByModal(false);
        clearFocus();
        dispatch(setSortType(event));
    };
    if (!show) {
        return null;
    }
    return (<>
            <FilterCheckboxBase onClick={() => setShowSortByModal(true)} testid={`SpotListSorter-button-${sortBy}`} key={sortBy} isActive={showSortByModal} order={0}>
                Sort:{' '}
                {getSortOptions.find(option => option.value === sortBy)
            ?.display}
                {<IconChevronDown width="10px" height="10px"/>}
            </FilterCheckboxBase>
            <AirportSortModal isOpen={showSortByModal} onClose={() => setShowSortByModal(false)} onChange={onChangeSort} currentSort={sortBy} sortOptions={getSortOptions}/>
        </>);
};
